import React from 'react';
import { Row } from './Flex';


export const FakeButton = ({
	children,
}: {
	children: React.ReactNode
}): React.JSX.Element => {
	return (
		<Row
			borderColor='iconActionDefault'
			className='border border-solid gap-xs leading-none rounded-sm w-fit'
			color='iconActionDefault'
			padding={{ all: 'md' }}
		>
			{children}
		</Row>
	);
};
